const API_BASE = '/api';

async function request(url, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  const response = await fetch(API_BASE + url, { ...options, headers });
  return response.json();
}

export const api = {
  getAbout: () => request('/about/index'),
  getEmployeeList: () => request('/employee/list'),
  getEmployeeDetail: (id) => request('/employee/detail?id=' + id),
  getAgentPage: () => request('/agent-page/index'),
  submitApplication: (data) => request('/application/submit', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
};
